import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledInlineFilterWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";

export const StyledFlexRowWrap = styled(FlexRow)`
    flex-wrap: wrap;
    display: inline-block;

    & > * {
        margin-bottom: 8px;
    }
`;

export const StyledIntentInlineFilterWrapper = styled(StyledInlineFilterWrapper)`
    margin-bottom: 16px;
`;
